import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Commands } from '@styles/icons/commands.svg';
import React from 'react';

export const CommandsIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Commands} viewBox={'0 0 20 20'} />
);

export default CommandsIcon;
